import {
  Button as ArborButton,
  type ButtonProps as ArborButtonProps,
} from '@linktr.ee/arbor/components/Button';
import { cn } from '@linktr.ee/arbor/utils/cn';
import type { ReactNode } from 'react';

export type ButtonProps = Omit<
  ArborButtonProps,
  'children' | 'icon' | 'iconComponent' | 'iconProps'
> & {
  label?: ReactNode;
  children?: ReactNode;
  icon?: ReactNode;
  fullWidth?: boolean;
};

const Button = ({
  label,
  children,
  icon,
  fullWidth = true,
  variant = 'outline',
  shape = 'capsule',
  size = 'xl',
  className,
  ...props
}: ButtonProps) => {
  const content = children ?? label;

  return (
    <ArborButton
      {...props}
      variant={variant}
      shape={shape}
      size={size}
      className={cn(fullWidth && 'w-full', className)}
    >
      {icon ? (
        <>
          <span className="flex shrink-0 items-center [&>svg]:size-5">
            {icon}
          </span>
          {content}
        </>
      ) : (
        content
      )}
    </ArborButton>
  );
};

export default Button;
